import { put, takeEvery } from 'redux-saga/effects';
import { getTenantSettings } from './api';
import { GET_TENANT_STATISTICS, CLEAR_TENANT_STATISTICS } from './constants';
import { getTenantStatisticsSuccess, clearReducerSuccess } from './actions';


/**
 *
 * @param data
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{result: *, type: string}>>|*, void, *>}
 */
function* tenantsStatisticsGet( data ) {
    const serverResponse = yield getTenantSettings( data );
    if ( serverResponse ) {
        yield put(  getTenantStatisticsSuccess( serverResponse ) );
    }
}

/**
 *
 * @returns {Generator<SimpleEffect<"PUT", PutEffectDescriptor<{type: string}>>, void, *>}
 */
function* tenantsStatisticsClear( ) {
    yield put( clearReducerSuccess() );
}



/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchTenantStatistics() {
    yield takeEvery( GET_TENANT_STATISTICS, tenantsStatisticsGet );
    yield takeEvery( CLEAR_TENANT_STATISTICS, tenantsStatisticsClear );
}

export default watchTenantStatistics;
